export const mergeClasses = (classes: (string | undefined)[]) => {
    return classes.join(' ');
}